import { S146gS146m01Component } from './s146g-s146m01.component';
import { S146gS146m02Component } from './s146g-s146m02.component';

export { S146gModule } from './s146g.module';

export const S146gSubComponentsMap = {
	
};

export const S146gComponentsMap = {
	"s146g-s146m01": S146gS146m01Component,
	"s146g-s146m02": S146gS146m02Component
};

export const S146gComponents = [
	S146gS146m01Component,
	S146gS146m02Component
];

